function main () {
  return 'latest';
}

export default main;
